module.exports = __webpack_public_path__ + "img/13.1.ee3aca3e.jpg";